import React from 'react';

import { gql } from '@reverbdotcom/commons/src/gql';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';

import { SellerHub_EarningsQuery, SellerHub_EarningsQueryVariables } from '@reverbdotcom/commons/src/gql/graphql';

interface IProps {
  timePeriod?: string;
}

export default function Earnings({ timePeriod = null }: IProps) {
  const { data, loading } = useQuery<SellerHub_EarningsQuery, SellerHub_EarningsQueryVariables>(SELLER_HUB_EARNINGS_QUERY, {
    variables: { timePeriod },
  });

  if (loading) {
    return null;
  }

  const totalEarnings = data?.me?.shop?.earnings?.ordersTotal?.display;

  if (!totalEarnings) {
    return null;
  }

  return (
    <div className="d-flex">
      <Translate
        tag="div"
        className="seller-hub__earnings"
        text="sellerHub.earnings.youveEarnedHtml"
        args={{
          tagOpen: '<span class="weight-bold">',
          tagClose: '</span>',
          totalEarnings: totalEarnings,
        }}
        html
      />
    </div>
  );
}

export const SELLER_HUB_EARNINGS_QUERY = gql(`
  query SellerHub_Earnings(
    $timePeriod: String
  ) {
    me {
      shop {
        earnings(input: {
          timePeriod: $timePeriod
        }) {
          ordersTotal {
            display
          }
        }
      }
    }
  }
`);
